export function routeForUser(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.status === "active") return "/app/home";
  return "/status";
}
